export default function About() {
  return <main id="about"></main>;
}
